<template>
  <span class="module-nav-bar-entry-container" v-tooltip.right="!isMenuEnabled(to) ? $t('TradeProNextDisabled') : ''">
    <a
      v-tooltip.right="tooltip"
      v-if="(!to || !isClickable) && !dropdown"
      class="btn"
      :class="{ 'module-nav-bar-entry': !expanded, 'module-nav-bar-entry-closed': expanded, active: active }"
      :data-cy="'module-' + name + '-link'">
      <i class="button-icon" v-safe-class="iconClasses"></i>
      <span class="button-name" v-if="!expanded"><slot></slot></span>
    </a>
    <router-link
      v-tooltip.right="tooltip"
      v-if="to && isClickable && !dropdown"
      :to="to"
      class="btn"
      :class="{
        'module-nav-bar-entry': !expanded,
        'module-nav-bar-entry-closed': expanded,
        active: active,
        disabled: !isMenuEnabled(to)
      }"
      :data-cy="'module-' + name + '-link'">
      <i class="button-icon" v-safe-class="iconClasses"></i>
      <span class="button-name" v-if="!expanded"><slot></slot></span>
    </router-link>

    <b-dd
      v-if="dropdown"
      class="module-nav-bar-entry-closed"
      menu-class="module-nav-bar-entry-dropdown-menu"
      no-caret
      :popper-opts="popperOpts"
      v-tooltip.right="tooltip">
      <template #button-content>
        <i class="button-icon" v-safe-class="iconClasses"></i>
      </template>
      <div class="module-nav-bar-entry-dropdown-items-container">
        <slot></slot>
      </div>
    </b-dd>
  </span>
</template>
<script>
import store from "@/store";
import router from "@/router";

export default {
  data() {
    return {
      popperOpts: {
        positionFixed: true,
        placement: "right-top",
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          offset: { offset: "0,10" }
        }
      }
    };
  },
  props: {
    to: { type: [String, Object], required: false },
    iconName: String,
    expanded: Boolean,
    active: Boolean,
    hasGeneralRouteForChildren: Boolean,
    dropdown: Boolean,
    variant: String,
    tooltip: String,
    title: String,
    name: String
  },
  computed: {
    iconClasses() {
      const icons = [];
      if (this.iconName) icons.push(this.iconName);
      if (this.variant) icons.push("text-" + this.variant);

      return icons;
    },
    isClickable() {
      const routeName = router.currentRoute.value.name;
      return !this.active || (this.to?.name !== routeName && this.hasGeneralRouteForChildren);
    }
  },
  methods: {
    isMenuEnabled(to) {
      if (to && to?.params && to?.params?.type == "TradeProNext") {
        return store.state.globalParameters.IsTradeProNextEnabled;
      }
      return true;
    }
  }
};
</script>
